<template>
  <v-app>
    <v-system-bar class="d-print-none pt-3" height="30" app lights-out>
      <v-toolbar-items class="text-right">
        <v-btn
          large
          rounded
          dark
          href="javascript:window.print()"
          class="title mr-2 rounded"
          color="info"
        >
          <v-icon class="mr-1" color="white" large>mdi-printer</v-icon>พิมพ์
        </v-btn>
      </v-toolbar-items>
    </v-system-bar>

    <div id="exportContent">
      <div class="page">
        <div align="center">
          <table width="100%">
            <tr>
              <td width="100%">
                <div class="head text-center">
                  แบบคำร้องขอย้ายพนักงานราชการประเภททั่วไป
                </div>
                <div class="head text-center">
                  สังกัดสำนักงานคณะกรรมการการอาชีวศึกษา
                </div>
              </td>
              <td>
                <table>
                  <tr>
                    <td></td>
                    <td
                      class="td text-center text_j_1"
                      width="72px"
                      height="90px"
                    >
                      <v-img
                        v-if="transference_personnels.personnel_temporary_pic"
                        contain
                        height="90px"
                        width="72px"
                        :src="
                          'https://hrvec.ovec.go.th/HRvecfiles/' +
                            transference_personnels.personnel_temporary_pic
                        "
                      ></v-img>
                      <img
                        v-else
                        height="90px"
                        width="72px"
                        src="https://hrvec.ovec.go.th/HRvecfiles/blank-human-image.png"
                      />
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
        <br />
        <table style="padding-top:5px" class="text_j" border="0" width="100%">
          <tr>
            <td width="50%"></td>
            <td width="15%">
              <div class="regular16">เขียนที่</div>
            </td>
            <td width="35%">
              <div class="regular16 td_line">
                {{ transference_personnels.college_name }}
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              <div class="regular16">วันที่ยื่นคำร้อง</div>
            </td>
            <td>
              <div class="regular16 td_line">
                {{
                  transference_personnels.date_time
                    | moment("add", "543 year")
                    | moment("D MMMM YYYY")
                }}
              </div>
            </td>
          </tr>
        </table>

        <br />

        <table border="0" width="100%">
          <tr>
            <td width="100%">
              <div class="regular16">
                <span class="font-weight-bold">เรื่อง</span>
                ขอย้ายพนักงานราชการทั่วไป
              </div>
            </td>
          </tr>
        </table>

        <table border="0" class="text_j" width="100%">
          <tr>
            <td width="100%">
              <div class="regular16">
                <span class="font-weight-bold">เรียน</span>
                เลขาธิการคณะกรรมการการอาชีวศึกษา
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td width="10%" class="text-left">ข้าพเจ้า</td>
            <td width="80%">
              <div class="regular16 td_line" align="center">
                {{
                  transference_personnels.title_s +
                    transference_personnels.frist_name +
                    " " +
                    transference_personnels.last_name
                }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="regular16">เกิดวันที่</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels.brith_day || "-" }}
              </div>
            </td>
            <td>
              <div class="regular16 text-center">เดือน</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{
                  transference_personnels.brith_month
                    | moment("add", "")
                    | moment("MMMM")
                }}
              </div>
            </td>
            <td>
              <div class="regular16 text-center">พ.ศ.</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels.brith_years || "-" }}
              </div>
            </td>
            <td>
              <div class="regular16" align="center">อายุ</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ get_ageUser }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="regular16">เลขประจำตัวประชาชน</div>
            </td>
            <td>
              <div class="regular16 td_line text-center">
                {{ transference_personnels.id_card }}
              </div>
            </td>
            <td class="text-center">ปัจจุบันอยู่บ้านเลขที่</td>
            <td>
              <div class="regular16 td_line text-center">
                {{ transference_personnels.pt_homeid }}
              </div>
            </td>

            <td class="text-center">หมู่ที่</td>
            <td>
              <div class="regular16 td_line text-center">
                {{ transference_personnels.pt_moo }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td>ถนน</td>
            <td>
              <div class="regular16 td_line">
                {{ transference_personnels.pt_road }}
              </div>
            </td>

            <td class="text-center">ตำบล/แขวง</td>
            <td>
              <div class="regular16 td_line">
                {{ transference_personnels.personnel_dist }}
              </div>
            </td>
            <td>อำเภอ/เขต</td>
            <td>
              <div class="regular16 td_line text-center">
                {{ transference_personnels.personnel_pref }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td>จังหวัด</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.personnel_prov }}
              </div>
            </td>

            <td class="text-center">รหัสไปรษณีย์</td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels.personnel_distpost }}
              </div>
            </td>
            <td class="text-center">โทรศัพท์</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.tel_p }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="8%">E-mail</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.e_mail }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="9%">ตำแหน่ง</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.position_name }}
              </div>
            </td>

            <td class="text-center" width="15%">ตำแหน่งเลขที่</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.id_position }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="8%">กลุ่มงาน</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.type_positition }}
              </div>
            </td>

            <td class="text-center" width="20%">รหัสตำแหน่ง/รหัสวิชา</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.id_branch_app }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="5%">สังกัด</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.college_name }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%">ปฏิบัติงานที่</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.college_name }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="50%">
              ได้รับการจัดจ้างเป็นพนักงานราชการทั่วไปครั้งแรก ตั้งแต่วันที่
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels.appoin_day || "-" }}
              </div>
            </td>
            <td width="5%">
              <div class="regular16 text-center">เดือน</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{
                  transference_personnels.appoin_month
                    | moment("add", "")
                    | moment("MMMM")
                }}
              </div>
            </td>
            <td width="5%">
              <div class="regular16 text-center">พ.ศ.</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ parseInt(transference_personnels.appoin_year) + 543 || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="20%">รวมระยะเวลาการจ้าง</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ transference_personnels.age_time }}
              </div>
            </td>

            <td class="text-center" width="15%">อัตราค่าตอบแทน</td>
            <td>
              <div class="regular16 td_line text-center" align="center">
                {{ numberWithCommas(transference_personnels.salary_s) }} บาท
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td>
              ประสงค์ขอย้ายไปปฏิบัติงาน (ระบุได้เพียงกรณีเดียว)
            </td>
          </tr>
        </table>

        <br />
        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              <div class="regular16">
                (
                <v-icon
                  color="black"
                  v-if="transference_personnels.case_moves === '0'"
                  >mdi-check-bold</v-icon
                >
                )
                <span class="bold16">กรณีย้ายไปตำแหน่งว่าง </span>
              </div>
            </td>
          </tr>
        </table>

        <table
          class="text_j"
          border="0"
          width="100%"
          align="center"
          v-for="item in transference_locations"
          :key="item.id_tfl"
          small
        >
          <tr>
            <td width="5%"></td>
            <td>
              <div class="regular16">{{ item.tlsequence_n }}. ตำแหน่ง</div>
            </td>
            <td>
              <div
                class="regular16 td_line"
                align="center"
                v-if="
                  transference_personnels.position_name ===
                    'พนักงานบริหารทั่วไป (ครู)'
                "
              >
                {{ transference_personnels.position_name }}
              </div>

              <div class="regular16 td_line" align="center" v-else>
                {{ transference_personnels.position_name }}
              </div>
            </td>
            <td
              v-if="
                transference_personnels.position_name ===
                  'พนักงานบริหารทั่วไป (ครู)'
              "
            >
              <div class="regular16" align="center">สาขาวิชา</div>
            </td>
            <td
              v-if="
                transference_personnels.position_name ===
                  'พนักงานบริหารทั่วไป (ครู)'
              "
            >
              <div class="regular16 td_line text-center">
                {{ item.name_branch }}
              </div>
            </td>
            <td>
              <div class="regular16" align="center">สังกัด</div>
            </td>
            <td>
              <div class="regular16 td_line text-center">
                {{ item.user_firstname + " " + item.user_lastname }}
              </div>
            </td>

           


          </tr>
          <tr>
              <td width="5%"></td>
               <td colspan="6">
              <div class="regular16 td_line text-center">
                {{ item.tlcollege_department }}
              </div>
            </td>
          </tr>
        </table>

        <br />

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td width="25%">
              <div class="regular16">
                (
                <v-icon
                  color="black"
                  v-if="transference_personnels.case_moves === '1'"
                  >mdi-check-bold</v-icon
                >
                ) กรณีขอย้ายสับเปลี่ยน
              </div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels_switch.title_s || "-"
                }}{{ transference_personnels_switch.frist_name || "" }}
                {{ transference_personnels_switch.last_name || "" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="30%">
              <div class="regular16">พนักงานราชการทั่วไป ตำแหน่ง</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels_switch.position_name || "-" }}
              </div>
            </td>
            <td>
              <div class="regular16 text-center" width="10%">เลขที่ตำแหน่ง</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels_switch.id_position || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="18%">
              <div class="regular16">สังกัด (สถานศึกษา)</div>
            </td>
            <td>
              <div class="regular16 td_line" align="center">
                {{ transference_personnels_switch.college_name || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              <div class="regular16">
                <span class="bold16">ข้าพเจ้าขอเรียนว่า</span>
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td>
              <div class="regular16 div-indent">
                1. ข้าพเจ้ามีคุณสมบัติและไม่มีลักษณะต้องห้าม
                ตามระเบียบสำนักนายกรัฐมนตรีว่าด้วยพนักงานราชการ พ.ศ. 2547
                และที่แก้ไขเพิ่มเติม
              </div>
            </td>
          </tr>
        </table>

        <div class="text-right mt-5">
          2.วินัย/คดีความ...
        </div>
        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 2 -->

        <div class="text-center mt-10">
          -2-
        </div>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>2. วินัย/คดีความ</td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="15%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_discipline === '1'"
                >mdi-check-bold</v-icon
              >
              ) เคยถูกลงโทษทางวินัย
            </td>
            <td width="5%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_discipline === '0'"
                >mdi-check-bold</v-icon
              >
              ) ไม่เคยถูกลงโทษทางวินัย
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="15%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_pro_discipline === '1'"
                >mdi-check-bold</v-icon
              >
              ) อยู่ในระหว่างถูกดำเนินการทางวินัย
            </td>
            <td width="5%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_pro_discipline === '0'"
                >mdi-check-bold</v-icon
              >
              ) ไม่อยู่ในระหว่างถูกดำเนินการทางวินัย
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="15%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_criminal === '1'"
                >mdi-check-bold</v-icon
              >
              ) อยู่ในระหว่างถูกดำเนินคดีอาญา
            </td>
            <td width="5%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_criminal === '0'"
                >mdi-check-bold</v-icon
              >
              ) ไม่อยู่ในระหว่างถูกดำเนินคดีอาญา
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="15%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_bankrupt === '1'"
                >mdi-check-bold</v-icon
              >
              ) อยู่ในระหว่างถูกดำเนินคดีล้มละลาย
            </td>
            <td width="5%"></td>
            <td width="35%">
              (
              <v-icon
                color="black"
                v-if="transference_personnels.tp_bankrupt === '0'"
                >mdi-check-bold</v-icon
              >
              ) ไม่อยู่ในระหว่างถูกดำเนินคดีล้มละลาย
            </td>
          </tr>
        </table>

        <br />

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              3. ประวัติการศึกษา
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" border="1" align="center">
          <tr>
            <td width="5%" class="text-center">ที่</td>
            <td class="text-center">คุณวุฒิ</td>
            <td class="text-center">สาขา/วิชาเอก</td>
            <td class="text-center">สถาบันการศึกษา</td>
          </tr>

          <tr v-for="(item, index) in personnel_educations" :key="item.id">
            <td width="5%" class="text-center">{{ (index += 1) }}</td>
            <td class="text-center">{{ item.faculty_name }}</td>
            <td class="text-center">{{ item.branch_name }}</td>
            <td class="text-center">{{ item.academy_name }}</td>
          </tr>
        </table>

        <br />
        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              4. ประวัติการปฏิบัติงาน
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" border="1" align="center">
          <tr>
            <td width="5%" class="text-center">ที่</td>
            <td class="text-center">วัน เดือน ปี</td>
            <td class="text-center">ลักษณะงานที่ปฏิบัติ</td>
            <td class="text-center">สถาบันการศึกษา</td>
          </tr>

          <tr v-for="(item, index) in personnel_dutys" :key="item.id">
            <td width="5%" class="text-center">{{ index + 1 }}</td>
            <td class="text-center">
              {{
                item.personnel_dutyDateTime
                  | moment("add", "543 year")
                  | moment("D MMMM YYYY")
              }}
            </td>
            <td class="text-center">{{ item.personnel_dutyTopic }}</td>
            <td class="text-center">
              {{ item.college_name }}
            </td>
          </tr>
        </table>

        <br />
        <table class="text_j" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent">
                5. ผลการปฏิบัติงานย้อนหลัง
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" border="0" align="center">
          <tr v-for="item in personnel_govem_assesment" :key="item.id">
            <td width="5%" class="text-center"></td>
            <td class="text-center">
              ครั้งที่
              <span class="font-weight-bold">{{
                item.govem_assesment_timeyear
              }}</span>
            </td>
            <td class="text-center">
              ระดับ
              <span class="font-weight-bold">{{
                item.govem_assesment_level
              }}</span>
            </td>
            <td class="text-center">
              คะแนน
              <span class="font-weight-bold">{{
                item.govem_assesment_score
              }}</span>
            </td>
            <td class="text-center"></td>
          </tr>
        </table>

        <br />
        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              6.ผลงานดีเด่นจากการปฏิบัติงาน
            </td>
          </tr>
        </table>

        <div class="div-indent">
          {{ transference_personnels.tp_knowleage }}
        </div>

        <div class="text-right mt-5">
          7. เหตุผล...
        </div>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 3 -->

        <div class="text-center mt-10">
          -3-
        </div>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent">
                7. เหตุผลการขอย้าย
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="90%" colspan="2">
              <div class="regular16">
                <v-icon
                  size="30"
                  color="black"
                  v-if="transference_personnels.reason_2 === '1'"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <v-icon size="30" color="black" v-else
                  >mdi-checkbox-blank-outline</v-icon
                >
                ย้ายเพื่อดูแลบิดา มารดา
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="15%" colspan="2">
              <div class="regular16">อายุของบิดา</div>
            </td>
            <td width="24%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.reason_2_fyear || "-" }} ปี
              </div>
            </td>
            <td width="15%" colspan="2" align="center">
              <div class="regular16">อายุของมารดา</div>
            </td>
            <td width="30%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.reason_2_myear || "-" }} ปี
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%">
              <div class="regular16"></div>
            </td>
            <td width="35%">
              <div class="regular16">ภูมิลำเนาของบิดา มารดา ตำบล/แขวง</div>
            </td>
            <td width="16%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r2_district || "-" }}
              </div>
            </td>
            <td width="13%">
              <div class="regular16 text-center">อำเภอ/เขต</div>
            </td>
            <td width="20%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r2_prefecture || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%">
              <div class="regular16"></div>
            </td>
            <td width="10%">
              <div class="regular16">จังหวัด</div>
            </td>
            <td width="74%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r2_province || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="45%" colspan="2">
              <div class="regular16">
                <v-icon
                  size="30"
                  color="black"
                  v-if="transference_personnels.reason_3 === '1'"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <v-icon size="30" color="black" v-else
                  >mdi-checkbox-blank-outline</v-icon
                >

                ย้ายกลับภูมิลำเนาของข้าพเจ้า ตำบล/แขวง
              </div>
            </td>
            <td width="17%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r3_district || "-" }}
              </div>
            </td>
            <td width="10%">
              <div class="regular16 text-center">อำเภอ/เขต</div>
            </td>
            <td width="18%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r3_prefecture || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%">
              <div class="regular16"></div>
            </td>
            <td width="10%">
              <div class="regular16">จังหวัด</div>
            </td>
            <td width="74%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r3_province || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="90%" colspan="2">
              <div class="regular16">
                <v-icon
                  size="30"
                  color="black"
                  v-if="transference_personnels.reason_1 === '1'"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <v-icon size="30" color="black" v-else
                  >mdi-checkbox-blank-outline</v-icon
                >
                ย้ายเพื่อยู่ร่วมคู่สมรส
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="10%" colspan="2">
              <div class="regular16">คู่สมรสชื่อ</div>
            </td>
            <td width="74%" colspan="2">
              <div class="regular16 td_line">
                {{ transference_personnels.reason_1_spouse || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16">คู่สมรสประกอบอาชีพ</div>
            </td>
            <td width="64%" colspan="2">
              <div class="regular16 td_line">
                {{ transference_personnels.reason_1_occupation || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="30%" colspan="2">
              <div class="regular16">สถานที่ประกอบอาชีพของคู่สมรส</div>
            </td>
            <td width="54%" colspan="2">
              <div class="regular16 td_line">
                {{ transference_personnels.reason_1_location || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="30%" colspan="2">
              <div class="regular16">ภูมิลำเนาของคู่สมรส ตำบล/แขวง</div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_district || "-" }}
              </div>
            </td>
            <td width="14%">
              <div class="regular16 text-center">อำเภอ/เขต</div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_prefecture || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%">
              <div class="regular16"></div>
            </td>
            <td width="10%">
              <div class="regular16">จังหวัด</div>
            </td>
            <td width="74%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_province || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="10%" colspan="2">
              <div class="regular16">บุตรชื่อ</div>
            </td>
            <td width="74%" colspan="2">
              <div class="regular16 td_line">
                {{ transference_personnels.reason_1_child || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="15%" colspan="2">
              <div class="regular16">อายุของบุตร</div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.reason_1_childage || "-" }}
              </div>
            </td>
            <td width="49%" colspan="2">
              <div class="regular16">ปี</div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="30%" colspan="2">
              <div class="regular16">ภูมิลำเนาของคู่สมรส ตำบล/แขวง</div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_childdistrict || "-" }}
              </div>
            </td>
            <td width="14%">
              <div class="regular16 text-center">อำเภอ/เขต</div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_childprefecture || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="16%">
              <div class="regular16"></div>
            </td>
            <td width="10%">
              <div class="regular16">จังหวัด</div>
            </td>
            <td width="74%">
              <div class="regular16 td_line text-center">
                {{ transference_personnels.r1_childprovince || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%" colspan="2">
              <div class="regular16"></div>
            </td>
            <td width="20%" colspan="2">
              <div class="regular16">
                <v-icon
                  size="30"
                  color="black"
                  v-if="transference_personnels.reason_4 === '1'"
                  >mdi-checkbox-marked-outline</v-icon
                >
                <v-icon size="30" color="black" v-else
                  >mdi-checkbox-blank-outline</v-icon
                >
                เหตุผลอื่น (ระบุ)
              </div>
            </td>
            <td width="70%" colspan="2">
              <div class="regular16 td_line">
                {{ transference_personnels.reason_4_detail || "-" }}
              </div>
            </td>
          </tr>
        </table>

        <br />
        <table class="text_j" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent">
                8. เอกสารหลักฐานต่าง ๆ ที่ส่งเพื่อประกอบการพิจารณา
                โดยรับรองสำเนาตามระเบียบ สำนักนายกรัฐมนตรีว่าด้วยงานสารบรรณ
                ดังนี้
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" width="100%" align="center">
          <tr>
            <td width="15%"></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_1 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              สำเนาสัญญาจ้าง ที่มีรายละเอียดครบถ้วน ตั้งแต่วันที่เริ่มสัญญาจ้าง
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_2 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>สำเนาทะเบียนบ้าน</td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_3 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              สำเนาปริญญาบัตร หรือเอกสารหลักฐานอื่นที่แสดงการสำเร็จการศึกษา
            </td>
          </tr>
          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_4 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>สำเนาระเบียนแสดงผลการศึกษา (Transcript)</td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_5 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              สำเนาเอกสารหลักฐานที่แสดงถึงผลประเมินการปฏิบัติงาน 2 ครั้งล่าสุด
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_6 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              สำเนาเอกสารหลักฐานที่แสดงถึงความรู้ความสามารถพิเศษ ที่เป็นประโยชน์
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>ต่อการปฏิบัติงาน</td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_7 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              สำเนาเอกสารหลักฐานอื่นที่เกี่ยวข้อง เช่น
              หนังสือสำคัญการเปลี่ยนชื่อ - สกุล
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td>ใบรับรองแพทย์ ใบสำคัญการสมรส เป็นต้น (ถ้ามี)</td>
          </tr>

          <tr>
            <td></td>
            <td>
              (
              <v-icon
                color="black"
                v-if="transference_personnels.evidence_info_8 === '1'"
                >mdi-check-bold</v-icon
              >
              )
            </td>
            <td>
              เอกสารหลักฐานอื่นที่เป็นประโยชน์ต่อการพิจารณาการย้าย
            </td>
          </tr>
        </table>

        <div class="text-right mt-5">
          ข้าพเจ้าขอรับรอง...
        </div>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 4 -->

        <div class="text-center mt-10">
          -4-
        </div>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent ">
                ข้าพเจ้าขอรับรองว่าข้อความและเอกสารหลักฐานตามที่ระบุถูกต้องตรงตามความจริง
                ทุกประการ
                และการย้ายนี้จะไม่เรียกร้องประโยชน์ตอบแทนและค่าใช้จ่ายอื่นใด
                นอกเหนือจากค่าตอบแทนและสิทธิประโยชน์ที่ได้รับอยู่เดิมจากสำนักงานคณะกรรมการการอาชีวศึกษา
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent ">
                จึงเรียนมาเพื่อโปรดพิจารณา
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%"></td>
            <td width="80%">
              <div class="text-center">
                ขอแสดงความนับถือ
              </div>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="text-center">
              <br />
              (ลงชื่อ)....................................................................ผู้ขอย้าย
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              (
              {{
                transference_personnels.title_s +
                  transference_personnels.frist_name +
                  " " +
                  transference_personnels.last_name
              }}
              )
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              ตำแหน่ง {{ transference_personnels.position_name }}
            </td>
          </tr>
        </table>

        <br />

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div>
                <span class="bold16"
                  >คำรับรองและความเห็นผู้บังคับบัญชาระดับต้น
                  (ระดับส่วน/กลุ่ม/กลุ่มงาน/แผนก/ฝ่าย หรือเทียบเท่า)</span
                >
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="div-indent">
                ขอรับรองว่าข้อความดังกล่าวข้างต้นเป็นความจริงและมีความเห็นเพื่อประกอบการพิจารณา
                ดังนี้
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%"></td>
            <td width="80%">
              <br />
              <div class="div-indent-sec">
                (ลงชื่อ)...........................................................ผู้บังคับบัญชาชั้นต้น
              </div>
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              (...............................................................)
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              ตำแหน่ง........................................................
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%"></td>
            <td width="80%">
              <div class="div-indent-sec">
                วันที่...............เดือน.............................พ.ศ................
              </div>
            </td>
          </tr>
        </table>

        <br />
        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="">
                <span class="bold16"
                  >ความเห็นของผู้บังคับบัญชา (ระดับสำนัก/หน่วย/กลุ่ม/ศูนย์
                  หรือผู้อำนวยการสถาบันการอาชีวศึกษา/สถานศึกษา)</span
                >
              </div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="10%"></td>
            <td>
              <v-icon size="30" color="black">mdi-checkbox-blank-outline</v-icon
              >ไม่ขัดข้อง
              และยินยอมให้พนักงานราชการรายดังกล่าวย้ายไปปฏิบัติงานที่ใหม่
            </td>
          </tr>
          <tr>
            <td width="10%"></td>
            <td>
              <v-icon size="30" color="black">mdi-checkbox-blank-outline</v-icon
              >ไม่ยินยอม
            </td>
          </tr>
          <tr>
            <td width="10%"></td>
            <td class="font-weight-bold">
              เหตุผล
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="td_line"></div>
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%"></td>
            <td width="80%">
              <br />
              <div class="div-indent-sec">
                (ลงชื่อ)...........................................................ผู้บังคับบัญชา
              </div>
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              (...............................................................)
            </td>
          </tr>

          <tr>
            <td></td>
            <td class="text-center">
              ตำแหน่ง........................................................
            </td>
          </tr>
        </table>

        <table class="text_j" border="0" width="100%" align="center">
          <tr>
            <td width="20%"></td>
            <td width="80%">
              <div class="div-indent-sec">
                วันที่...............เดือน.............................พ.ศ................
              </div>
            </td>
          </tr>
        </table>

        <!-- New Page -->
        <p style="page-break-before: always;">&nbsp;</p>
        <!-- 5 -->

        <div v-if="transference_personnels.case_moves === '1'">
          <div class="text-center mt-10">
            -5-
          </div>

          <div class="font-weight-bold text-center mt-5">
            กรณีขอย้ายสับเปลี่ยน
          </div>
          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div class="">
                  <span class="bold16">หน่วยงานปลายทาง</span>
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="10%">ผู้ขอย้าย</td>
              <td width="90%">
                <div class="regular16 td_line text-center">
                  {{
                    transference_personnels.title_s +
                      transference_personnels.frist_name +
                      " " +
                      transference_personnels.last_name
                  }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" width="100%" align="center">
            <tr>
              <td width="10%">ตำแหน่ง</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels.position_name }}
                </div>
              </td>

              <td class="text-center">ตำแหน่งเลขที่</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels.id_position }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" width="100%" align="center">
            <tr>
              <td width="10%">สังกัด</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels.college_name }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="10%">คู่สับเปลี่ยน</td>
              <td width="90%">
                <div class="regular16 td_line text-center">
                  {{
                    transference_personnels_switch.title_s +
                      transference_personnels_switch.frist_name +
                      " " +
                      transference_personnels_switch.last_name
                  }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" width="100%" align="center">
            <tr>
              <td width="10%">ตำแหน่ง</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels_switch.position_name }}
                </div>
              </td>

              <td class="text-center">ตำแหน่งเลขที่</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels_switch.id_position }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" width="100%" align="center">
            <tr>
              <td width="10%">สังกัด</td>
              <td>
                <div class="regular16 td_line text-center" align="center">
                  {{ transference_personnels_switch.college_name }}
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div class="div-indent">
                  บัดนี้
                  ข้าพเจ้าทั้งสองยินยอมตกลงขอย้ายสับเปลี่ยนกันโดยไม่ได้เรียกร้องสิ่งใดๆ
                  จากกันและกัน จึงได้ลงลายมือขื่อไว้เป็นหลักฐานพร้อมนี้
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="30%"></td>
              <td width="70%"></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-center">
                (ลงชื่อ)....................................................................ผู้ขอย้าย
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                (
                {{
                  transference_personnels.title_s +
                    transference_personnels.frist_name +
                    " " +
                    transference_personnels.last_name
                }}
                )
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                ตำแหน่ง {{ transference_personnels.position_name }}
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="30%"></td>
              <td width="70%"></td>
            </tr>
            <tr>
              <td></td>
              <td class="text-center">
                (ลงชื่อ)....................................................................คู่สับเปลี่ยน
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                (
                {{
                  transference_personnels_switch.title_s +
                    transference_personnels_switch.frist_name +
                    " " +
                    transference_personnels_switch.last_name
                }}
                )
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                ตำแหน่ง {{ transference_personnels_switch.position_name }}
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div>
                  <span class="bold16"
                    >คำรับรองและความเห็นผู้บังคับบัญชาระดับต้น
                    (ระดับส่วน/กลุ่ม/กลุ่มงาน/แผนก/ฝ่าย หรือเทียบเท่า)</span
                  >
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="20%"></td>
              <td width="80%">
                <br />
                <div class="div-indent-sec">
                  (ลงชื่อ)...........................................................ผู้บังคับบัญชาชั้นต้น
                </div>
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                (...............................................................)
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                ตำแหน่ง........................................................
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="20%"></td>
              <td width="80%">
                <div class="div-indent-sec">
                  วันที่...............เดือน.............................พ.ศ................
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div class="">
                  <span class="bold16"
                    >ความเห็นของผู้บังคับบัญชา (ระดับสำนัก/หน่วย/กลุ่ม/ศูนย์
                    หรือผู้อำนวยการสถาบันการอาชีวศึกษา/สถานศึกษา)</span
                  >
                </div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="10%"></td>
              <td>
                <v-icon size="30" color="black"
                  >mdi-checkbox-blank-outline</v-icon
                >ไม่ขัดข้อง
                และยินยอมให้พนักงานราชการรายดังกล่าวย้ายไปปฏิบัติงานที่ใหม่
              </td>
            </tr>
            <tr>
              <td width="10%"></td>
              <td>
                <v-icon size="30" color="black"
                  >mdi-checkbox-blank-outline</v-icon
                >ไม่ยินยอม
              </td>
            </tr>
            <tr>
              <td width="10%"></td>
              <td class="font-weight-bold">
                เหตุผล
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="td_line"></div>
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="20%"></td>
              <td width="80%">
                <br />
                <div class="div-indent-sec">
                  (ลงชื่อ)...........................................................ผู้บังคับบัญชา
                </div>
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                (...............................................................)
              </td>
            </tr>

            <tr>
              <td></td>
              <td class="text-center">
                ตำแหน่ง........................................................
              </td>
            </tr>
          </table>

          <table class="text_j" border="0" width="100%" align="center">
            <tr>
              <td width="20%"></td>
              <td width="80%">
                <div class="div-indent-sec">
                  วันที่...............เดือน.............................พ.ศ................
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: "App",
  data: () => ({
    ApiKey: "HRvec2021",
    transference_personnels: [],
    transference_personnels: [],
    personnel_educations: [],
    transference_locations: [],
    transference_personnels_switch: [],
    province_sh_s: [],
    province_sh_fm: [],
    province_sh_m: [],
    valid: true,
    personnel_award_id: [],
    periods: [],
    personnel_dutys: [],
    personnel_awards: [],
    personnel_govem_assesment: []
  }),

  async mounted() {
    await this.sweetAlertLoading();
    await this.periodQueryAll();
    await this.transference_personnelsQueryAll();
    await this.personnel_educationsQueryAll();
    await this.transference_locationsQueryAll();
    await this.transference_personnels_switchQueryAll();
    await this.updatetransference_personnels_award();
    await this.personnel_dutysQueryAll();
    await this.personnel_awardsQueryAll();
    await this.personnel_govem_assesmentQueryAll();
    Swal.close();
  },

  methods: {
    async personnel_govem_assesmentQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("personnel_govem_assesment.php", {
          ApiKey: this.ApiKey,
          personnel_govem_assesment_idcard: this.transference_personnels.id_card
        })
        .finally(() => (this.loading = false));
      // ดึงข้อมูลทั้งหมด
      let allData = result.data || [];

      // ตรวจสอบว่ามีข้อมูลหรือไม่
      if (!allData || allData.length === 0) {
        this.personnel_govem_assesment = [];
        this.redirectToProfile(
          "ไม่พบข้อมูลการประเมินปฏิบัติงาน กรุณาติดต่อเจ้าหน้าที่"
        );
        return;
      }

      // เรียงลำดับตามปีและครั้งที่ (DESC) - ล่าสุดก่อน
      const sortedData = allData.sort((a, b) => {
        // แปลง govem_assesment_timeyear จาก "1/2568" เป็นการเปรียบเทียบ
        const parseTimeYear = timeYear => {
          if (!timeYear) return { time: 0, year: 0 };
          const parts = timeYear.split("/");
          return {
            time: parseInt(parts[0]) || 0,
            year: parseInt(parts[1]) || 0
          };
        };

        const aData = parseTimeYear(a.govem_assesment_timeyear);
        const bData = parseTimeYear(b.govem_assesment_timeyear);

        // เรียงตามปีก่อน (DESC)
        if (bData.year !== aData.year) {
          return bData.year - aData.year;
        }
        // ถ้าปีเดียวกัน เรียงตามครั้งที่ (DESC)
        return bData.time - aData.time;
      });

      // ดึงเฉพาะ 2 รายการล่าสุด
      const latest2Records = sortedData.slice(0, 2);

      // เก็บข้อมูลทั้งหมดและข้อมูล 2 รายการล่าสุด
      this.personnel_govem_assesment = allData; // ข้อมูลทั้งหมด
    },
    numberWithCommas(x) {
      x = String(x);
      var pattern = /(-?\d+)(\d{3})/;
      while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
      return x;
    },
    async personnel_awardsQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("personnel_award.php", {
          ApiKey: this.ApiKey,
          personnel_awardid_card: this.transference_personnels.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_awards = result.data;
    },

    async personnel_dutysQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("personnel_duty.php", {
          ApiKey: this.ApiKey,
          personnel_dutyIDCard: this.transference_personnels.id_card
        })
        .finally(() => (this.loading = false));
      this.personnel_dutys = result.data;
    },

    async periodQueryAll() {
      let result_period;
      result_period = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_enable_process: "1",
        period_id: "401"
      });
      this.periods = result_period.data;
    },

    async updatetransference_personnels_award() {
      let result = await this.$http.post("personnel_award.php", {
        ApiKey: this.ApiKey,
        id_pa: this.transference_personnels.tp_award
      });
      this.personnel_award_id = result.data;
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        onBeforeOpen: () => {
          Swal.showLoading();
        },
        onAfterClose: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },




    async transference_personnelsQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_personnel_govem.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        })
        .finally(() => (this.loading = false));
      this.transference_personnels = result.data;
    },

    async transference_personnels_switchQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          id_card: this.transference_personnels.switch_position
        })
        .finally(() => (this.loading = false));
      this.transference_personnels_switch = result.data;
    },

    async personnel_educationsQueryAll() {
      let result = await this.$http.post("personnel_education.php", {
        ApiKey: this.ApiKey,
        id_card: this.transference_personnels.id_card
      });
      this.personnel_educations = result.data;
    },

    async transference_locationsQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("transference_location.php", {
          ApiKey: this.ApiKey,
          id_ref: this.id_ref
        })
        .finally(() => (this.loading = false));
      this.transference_locations = result.data;
    },

    Export2Doc(element, filename) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword"
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      filename = filename ? filename + ".doc" : "document.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    }
  },
  computed: {
            date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

        get_ageUser() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(
        parseInt(this.transference_personnels.brith_year) +
          "-" +
          this.transference_personnels.brith_month +
          "-" +
          this.transference_personnels.brith_day
      );
      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = 0;
        else months = totalMonths % 12;
      }
      let age = years + " ปี";
      return age;
    },
    
    dateToday() {
      return new Date();
    },
    id_ref() {
      return this.$route.query.id_ref;
    },
    day_tims() {
      let period_start = String(this.periods.period_start);
      let split_start = period_start.split("-");
      let result = split_start[2];
      return result;
    },
    marital_status() {
      let marital_status = this.transference_personnels.marital_status;
      let marital_result;
      if (marital_status == "single") {
        marital_result = "โสด";
      } else if (marital_status == "married") {
        marital_result = "สมรส";
      } else if (marital_status == "widow") {
        marital_result = "หม้าย";
      } else if (marital_status == "divorce") {
        marital_result = "หย่า";
      } else if (marital_status == "separate") {
        marital_result = "แยกกันอยู่";
      }
      return marital_result;
    },

    date_today_cal() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      today = yyyy + "-" + mm + "-" + dd;
      return today;
    },

    get_gov_Age() {
      let today = new Date(this.date_today_cal);
      let DOB = new Date(this.transference_personnels.ser_date);
      let totalMonths =
        (today.getFullYear() - DOB.getFullYear()) * 12 +
        today.getMonth() -
        DOB.getMonth();
      totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
      let years = today.getFullYear() - DOB.getFullYear();
      if (DOB.getMonth() > today.getMonth()) years = years - 1;
      else if (DOB.getMonth() === today.getMonth())
        if (DOB.getDate() > today.getDate()) years = years - 1;

      let days;
      let months;

      if (DOB.getDate() > today.getDate()) {
        months = totalMonths % 12;
        if (months == 0) months = 11;
        let x = today.getMonth();
        switch (x) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 8:
          case 10:
          case 12: {
            let a = DOB.getDate() - today.getDate();
            days = 31 - a;
            break;
          }
          default: {
            let a = DOB.getDate() - today.getDate();
            days = 30 - a;
            break;
          }
        }
      } else {
        days = today.getDate() - DOB.getDate();
        if (DOB.getMonth() === today.getMonth()) months = totalMonths % 12;
        else months = totalMonths % 12;
      }
      let age = years + " ปี " + months + " เดือน " + days + " วัน";
      return age;
    }
  },
  props: {
    source: String
  }
};
</script>
<style>
@import url(
  https://fonts.googleapis.com/css?family=Prompt:400,
  300|Roboto:400,
  300&subset=latin,
  thai
);

body {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16px;
  font-weight: 250;
}

u {
  border-bottom: 1px dotted #000;
  text-decoration: none;
}

* {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  box-sizing: border-box;
  -moz-box-sizing: border-box;
}

.table,
.th,
.td {
  border-bottom: 0.5px solid black;
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-right: 1px solid black;
  border-collapse: collapse;
}

.text_j {
  width: 100%;
  border-collapse: collapse;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1;
}

.text_j td {
  padding: 0;
  vertical-align: bottom;
  height: 18pt; /* ความสูงของแต่ละบรรทัด เหมาะสำหรับ 16pt */
}

tfoot tr:hover {
  background-color: initial;
}

tbody tr:hover {
  background-color: inherit;
}

td,
th {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
}

tfoot td {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-weight: bold;
}

#verticaltext {
  writing-mode: tb-rl;
  filter: flipv fliph;
  -webkit-transform: rotate(-90deg);
  white-space: nowrap;
  display: block;
  overflow: hidden;
  padding: 0;
}

.page {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  width: 21cm;
  min-height: 29.7cm;
  border: 1px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  margin-top: 0cm;
  margin-right: auto;
  margin-bottom: 0cm;
  margin-left: auto;
  padding-top: 1.5cm;
  padding-right: 1.5cm;
  padding-bottom: 1.75cm;
  padding-left: 1.5cm;
}

.div-indent {
  text-indent: 3em;
}
.div-indent-sec {
  text-indent: 6.5em;
}

.head {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
  line-height: 1;
}

.regular12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
}

.regular16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
}

.bold16 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 16pt;
  font-weight: bold;
}

.blod12 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 14pt;
  font-weight: bold;
}

.blackRegula10 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 12pt;
}

.blackBold18 {
  font-family: "TH SarabunIT๙", "TH SarabunPSK";
  font-size: 18pt;
  font-weight: bold;
}

.largerCheckbox {
  width: 30px;
  height: 30px;
  color: blue;
}

.td_line {
  width: 100%;
  border-bottom: 1px dotted #333;
  margin-bottom: 2pt;
}

.margin-line {
  border-left: 2px solid #ff6b6b;
  padding-left: 20px;
}

/*.subpage {
    height: 247mm;
  }*/

.BlackBold10 {
  font-weight: bold;
}

#content {
  display: table;
}

#pageFooter {
  display: table-footer-group;
}

#pageFooter:after {
  counter-increment: page;
  content: counter(page);
}

@media print {
  .page {
    border: initial;
    border-radius: initial;
    width: initial;
    min-height: initial;
    box-shadow: initial;
    background: initial;
    padding-top: 1.5cm;
    padding-right: 1.5cm;
    padding-bottom: 1.5cm;
    padding-left: 1.5cm;
  }

  .td_line {
    border-bottom: 1px dotted #000;
  }

  .head {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  .regular12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .regular16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
  }

  .bold16 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blod12 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 16pt;
    font-weight: bold;
  }

  .blackRegula10 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 14pt;
  }

  .blackBold18 {
    font-family: "TH SarabunIT๙", "TH SarabunPSK";
    font-size: 18pt;
    font-weight: bold;
  }

  /* .head {
      font-size: 18px;
      font-weight: bold;
    }
    .regular12 {
      font-size: 12px;
    }
    .blod12 {
      font-size: 12px;
      font-weight: bold;
    }
    .blackRegula8 {
      font-size: 8px;
    } */
  .noprint {
    display: none;
  }
}
</style>
